module.exports = __webpack_public_path__ + "static/media/hoop-app.6dfe5780.svg";